import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { app } from './config';

// Import analytics từ config.js để đảm bảo chỉ khởi tạo 1 lần
import { analytics as configAnalytics } from './config';

// Sử dụng instance analytics đã khởi tạo từ config
let analytics = configAnalytics;

// Kiểm tra kết nối mạng
const isOnline = () => {
  return typeof navigator !== 'undefined' && navigator.onLine;
};

// Hàm tiện ích để theo dõi sự kiện trang
export const trackPageView = (pageName, pageClass = '') => {
  if (!analytics || !isOnline()) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`Analytics tracking skipped for page ${pageName}: ${!analytics ? 'Analytics not initialized' : 'Device is offline'}`);
    }
    return;
  }

  try {
    // Theo dõi page view
    logEvent(analytics, 'page_view', {
      page_title: pageName,
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_class: pageClass
    });
    
    // Theo dõi screen view (mobile analytics)
    logEvent(analytics, 'screen_view', {
      screen_name: pageName,
      screen_class: pageClass || 'App'
    });
    
    if (process.env.NODE_ENV === 'development') {
      console.log(`Analytics: Tracked page view - ${pageName} (${pageClass})`);
    }
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Hàm tiện ích để theo dõi sự kiện
export const trackEvent = (eventName, eventParams = {}) => {
  if (!analytics || !isOnline()) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`Analytics tracking skipped for event ${eventName}: ${!analytics ? 'Analytics not initialized' : 'Device is offline'}`);
    }
    return;
  }

  try {
    // Kiểm tra xem người dùng đã đồng ý cho analytics hay chưa
    const storedConsent = localStorage.getItem('cookieConsent');
    if (storedConsent) {
      const consentData = JSON.parse(storedConsent);
      if (!consentData.analytics) {
        // Nếu không có consent cho analytics, không theo dõi bất kỳ sự kiện nào
        if (process.env.NODE_ENV === 'development') {
          console.log(`Analytics tracking skipped for event ${eventName}: No consent`);
        }
        return;
      }
    }
    
    logEvent(analytics, eventName, eventParams);
    if (process.env.NODE_ENV === 'development') {
      console.log(`Event tracked: ${eventName}`, eventParams);
    }
  } catch (error) {
    console.error(`Error tracking event ${eventName}:`, error);
  }
};

// Hàm đặt ID người dùng khi họ đăng nhập
export const setAnalyticsUserId = (uid) => {
  if (!analytics || !isOnline() || !uid) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`Analytics user ID setting skipped: ${!analytics ? 'Analytics not initialized' : !isOnline() ? 'Device is offline' : 'No UID provided'}`);
    }
    return;
  }

  try {
    // Kiểm tra xem người dùng đã đồng ý cho analytics hay chưa
    const storedConsent = localStorage.getItem('cookieConsent');
    if (storedConsent) {
      const consentData = JSON.parse(storedConsent);
      if (!consentData.analytics) {
        // Nếu không có consent cho analytics, không đặt ID người dùng
        if (process.env.NODE_ENV === 'development') {
          console.log(`Analytics user ID setting skipped: No consent`);
        }
        return;
      }
    }
    
    setUserId(analytics, uid);
    if (process.env.NODE_ENV === 'development') {
      console.log(`User ID set for analytics: ${uid}`);
    }
  } catch (error) {
    console.error('Error setting user ID for analytics:', error);
  }
};

// Hàm đặt thuộc tính người dùng
export const setAnalyticsUserProperties = (properties) => {
  if (!analytics || !isOnline() || !properties) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`Analytics user properties setting skipped: ${!analytics ? 'Analytics not initialized' : !isOnline() ? 'Device is offline' : 'No properties provided'}`);
    }
    return;
  }

  try {
    // Kiểm tra xem người dùng đã đồng ý cho analytics hay chưa
    const storedConsent = localStorage.getItem('cookieConsent');
    if (storedConsent) {
      const consentData = JSON.parse(storedConsent);
      if (!consentData.analytics) {
        // Nếu không có consent cho analytics, không đặt thuộc tính người dùng
        if (process.env.NODE_ENV === 'development') {
          console.log(`Analytics user properties setting skipped: No consent`);
        }
        return;
      }
    }
    
    setUserProperties(analytics, properties);
    if (process.env.NODE_ENV === 'development') {
      console.log('User properties set for analytics:', properties);
    }
  } catch (error) {
    console.error('Error setting user properties for analytics:', error);
  }
};

export { app }; 